<!--<app-notification-expired *ngIf="productObject && productObject.expired"></app-notification-expired>-->
<div *ngIf="productObject.ProductType.name == 'Event'">
  <app-event [productObject]="productObject"></app-event>
</div>
<div *ngIf="productObject.ProductType.name == 'Physical Product'">
  <app-physical-product [productObject]="productObject"></app-physical-product>
</div>
<div *ngIf="productObject.ProductType.name == 'Subscription'">
  <app-subscription [productObject]="productObject"></app-subscription>
</div>
<div *ngIf="productObject.ProductType.name == 'Invoice'">
  <app-invoice [productObject]="productObject"></app-invoice>
</div>
<div *ngIf="productObject.ProductType.name == 'Calendar'">
  <app-calendar [productObject]="productObject"></app-calendar>
</div>
<div *ngIf="productObject.ProductType.name == 'Quick Payment'">
  <app-quick-payment [productObject]="productObject"></app-quick-payment>
</div>
<div *ngIf="productObject.ProductType.name == 'Reservation'">
  <app-reservation  [productObject]="productObject">
  </app-reservation>
</div>
<div *ngIf="productObject.ProductType.name == 'Collection'">
  <app-claim  [productObject]="productObject">
  </app-claim>
</div>
